<template>
  <nav class="px-box-4" aria-label="Breadcrumb">
    <ul class="flex flex-wrap mt-2 text-11 text-gray-400 font-semibold">
      <li class="trail pt-2" v-for="(item, index) in trails" :key="`trail-${index}`">
        <a v-if="item.link" class="underline hover:text-red-400" :href="item.link">{{
          item.label
        }}</a>
        <template v-else>{{ item.label }}</template>
      </li>
      <li v-if="content.lastPage" class="pt-2 truncate max-w-xs">
        {{ content.lastPage }}
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
import type { BreadcrumbList, WithContext } from 'schema-dts'
import { PageTypes } from '@core/constants/pages'
import type { GQLBreadcrumbSlice } from './generated/breadcrumb'

const props = defineProps<{ content: GQLBreadcrumbSlice }>()

const { $t } = useNuxtApp()

const route = useRoute()

const trails = computed(() => {
  if (route.meta.pageType === PageTypes.TRANSFER) {
    return [
      {
        label: $t('breadcrumb.home'),
        link: getHomeUrl(),
      },
      {
        label: $t('breadcrumb.money_transfer_comparison'),
        link: getCountryUrl(),
      },
      ...props.content.trail,
    ]
  }

  return [
    {
      label: $t('breadcrumb.home'),
      link: getHomeUrl(),
    },
    ...props.content.trail,
  ].filter((b) => !hasInvalidPlaceholderValue(b.label))
})

const breadcrumbMarkup: WithContext<BreadcrumbList> = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: trails.value.map(({ label, link }, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    item: { '@id': link ?? '', name: label },
  })),
}
useHead({
  script: [{ type: 'application/ld+json', innerHTML: JSON.stringify(breadcrumbMarkup) }],
})
</script>

<style scoped>
.trail::after {
  @apply m-2;
  content: '>';
}

.trail:last-child::after {
  @apply m-0;
  content: '';
}
</style>
